import React from "react";
import { useMount } from "react-use";

import { Layout, Button, PageTitle, DescriptionText } from "@src/packages/chime-ui";

import { Shield } from "@src/components";
import { useIncode } from "./IncodeContext";

export const DocumentTypeSelector = () => {
  const { navigateTo, track } = useIncode();

  useMount(() => track("document_type_selector_viewed"));

  return (
    <Layout>
      <Shield />
      <PageTitle role="heading" center>
        Upload a photo ID
      </PageTitle>
      <DescriptionText center>We require a photo of a government ID to verify your identity</DescriptionText>
      <DescriptionText>Choose 1 of the following options</DescriptionText>
      <Button
        name="id"
        onClick={() => {
          track("document_type_drivers_license");
          navigateTo("tutorial_front");
        }}
      >
        Driver&apos;s License or ID Card
      </Button>
      <Button
        name="passport"
        onClick={() => {
          track("document_type_passport");
          navigateTo("tutorial_passport");
        }}
      >
        Passport
      </Button>
      <Button
        name="permanent-resident-card"
        onClick={() => {
          track("document_type_resident_card");
          navigateTo("tutorial_front");
        }}
      >
        Permanent Resident Card
      </Button>
      <Button
        name="work-permit"
        onClick={() => {
          track("document_type_work_permit");
          navigateTo("tutorial_front");
        }}
      >
        Work Permit
      </Button>
    </Layout>
  );
};
